import { parseEntityRef, stringifyEntityRef, UserEntity } from "@backstage/catalog-model";
import { useApi } from "@backstage/core-plugin-api";
import { AboutField } from "@backstage/plugin-catalog";
import { catalogApiRef } from "@backstage/plugin-catalog-react";
import { Avatar, Link } from "@backstage/core-components";
import { Grid, IconButton, SvgIcon, Typography } from "@material-ui/core";
import EmailIcon from "@material-ui/icons/Email";
import React from "react";
import { useEffect, useState } from "react";
import { getCachedUser } from "./utils";

//<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 30 30">
const TeamsIcon = () => <SvgIcon viewBox="0 0 30 30"><path d="M 16.5 3 A 3.5 3.5 0 0 0 13.339844 8 L 4 8 C 2.895 8 2 8.895 2 10 L 2 20 C 2 21.105 2.895 22 4 22 L 14 22 C 15.105 22 16 21.105 16 20 L 16 10 C 16 9.987256 15.996331 9.9755777 15.996094 9.9628906 A 3.5 3.5 0 0 0 16.5 10 A 3.5 3.5 0 1 0 16.5 3 z M 24 5 A 2.5 2.5 0 0 0 24 10 A 2.5 2.5 0 0 0 24 5 z M 6 11 L 8.5 11 L 9.5 11 L 12 11 L 12 12 L 9.5 12 L 9.5 19 L 8.5 19 L 8.5 12 L 6 12 L 6 11 z M 18 12 L 18 20 C 18 22.21 16.21 24 14 24 L 11.019531 24 C 12.179531 25.8 14.2 27 16.5 27 C 20.09 27 23 24.09 23 20.5 L 23 14 C 23 12.9 22.1 12 21 12 L 18 12 z M 24.460938 12 C 24.800938 12.59 25 13.27 25 14 L 25 20.5 C 25 21.35 24.880625 22.169453 24.640625 22.939453 C 26.550625 22.639453 28 20.99 28 19 L 28 14 C 28 12.9 27.1 12 26 12 L 24.460938 12 z"></path></SvgIcon>;

export const UserAndTitleField = ({ user, title, onlyAvatar, gridSizes }: { user: string | UserEntity | undefined, title: string, onlyAvatar?: boolean, gridSizes?: Record<string, number> | undefined }) => {
    const [userEntity, setUserEntity] = useState<UserEntity | null>(null);
    const catalogApi = useApi(catalogApiRef);
    useEffect(() => {
        if (user !== undefined) {
            const userFactory = async (userRef: string): Promise<UserEntity | null> => {
                try {
                    const entity = await catalogApi.getEntityByRef(userRef);
                    return entity as UserEntity;
                } catch {
                    return null;
                }
            };

            const fetchUser = async () => {
                if (typeof user === 'string') {
                    const ref = stringifyEntityRef(parseEntityRef(user, { defaultKind: 'User', defaultNamespace: 'default' }));
                    let cachedUser = await getCachedUser(ref, userFactory);
                    setUserEntity(cachedUser || null);
                } else {
                    setUserEntity(user || null);
                }
            };
            fetchUser();
        }
    }, [user, catalogApi]);
    return (
        <Grid item {...gridSizes}>
            <AboutField label={title}>
                {userEntity !== null ? <UserCard user={userEntity} onlyAvatar={onlyAvatar === undefined ? true : onlyAvatar} /> : <span>{user as string ?? "Not set"}</span>}
            </AboutField>
        </Grid>
    );
    ;
};

const UserCard = (props: { user: UserEntity | null, onlyAvatar: boolean }) => {
    const { user, onlyAvatar } = props;
    return (user !== null ? <Grid container>
        <Grid item>
            <Link to={`/catalog/${user.metadata.namespace}/user/${user.metadata.name}`}>
                <Avatar displayName={user.spec.profile?.displayName} picture={user.spec.profile?.picture} />
            </Link>
        </Grid>
        {!onlyAvatar &&
            <Grid item>
                <Typography variant='h4'><Link to={`/catalog/${user.metadata.namespace}/user/${user.metadata.name}`}>{user.spec.profile?.displayName}</Link></Typography>
                <Grid container direction="row">
                    <Grid item><IconButton href={`mailto:${user.spec.profile?.email}`} target="_blank" style={{padding: 0}}><EmailIcon /></IconButton></Grid>
                    <Grid item><IconButton href={`msteams://teams.microsoft.com/l/chat/0/0?users=${user.spec.profile?.email}`} style={{padding: 0}}><TeamsIcon /></IconButton></Grid>
                </Grid>
            </Grid>}
    </Grid> : null)
}

